import { StyleSheet, View, useWindowDimensions } from 'react-native';
import { colors, radii, spacing } from '~/ui/tokens';
import { SkeletonBlock } from './ui/Skeleton';

export function SearchResultsSkeleton() {
  const { width } = useWindowDimensions();
  const stacked = width < 720;

  return (
    <View style={styles.list} accessibilityLabel="Loading hotel results">
      {[0, 1, 2].map((index) => (
        <View key={index} style={[styles.card, stacked && styles.cardStacked]}>
          <SkeletonBlock style={[styles.image, stacked && styles.imageStacked]} />
          <View style={styles.info}>
            <SkeletonBlock style={[styles.line, styles.lineShort]} />
            <SkeletonBlock style={[styles.line, styles.title]} />
            <SkeletonBlock style={[styles.line, styles.lineMedium]} />
            <SkeletonBlock style={[styles.line, styles.lineLong]} />
          </View>
          <View style={[styles.price, stacked && styles.priceStacked]}>
            <SkeletonBlock style={[styles.line, styles.lineShort]} />
            <SkeletonBlock style={[styles.line, styles.priceNumber]} />
            <SkeletonBlock style={[styles.line, styles.button]} />
          </View>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  list: { gap: spacing(1.5) },
  card: {
    minHeight: 224,
    flexDirection: 'row',
    gap: spacing(2),
    padding: spacing(1.5),
    backgroundColor: colors.card,
    borderWidth: 1,
    borderColor: colors.line,
    borderRadius: radii.md,
  },
  cardStacked: { flexDirection: 'column' },
  image: { width: 250, borderRadius: radii.sm },
  imageStacked: { width: '100%', height: 190 },
  info: { flex: 1, gap: spacing(1.25), paddingTop: spacing(1) },
  price: { width: 224, gap: spacing(1.5), paddingTop: spacing(1), borderLeftWidth: 1, borderLeftColor: colors.lineSoft, paddingLeft: spacing(2) },
  priceStacked: { width: '100%', borderLeftWidth: 0, borderTopWidth: 1, borderTopColor: colors.lineSoft, paddingLeft: 0, paddingTop: spacing(2) },
  line: { height: 12, borderRadius: radii.sm },
  lineShort: { width: '35%' },
  lineMedium: { width: '62%' },
  lineLong: { width: '84%' },
  title: { width: '72%', height: 24 },
  priceNumber: { width: '58%', height: 34 },
  button: { width: '100%', height: 42, marginTop: 'auto' },
});
